// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"93":"1259b64b","590":"c5bbfc2e","872":"82e45761"}[chunkId] + ".chunk.js");